<template>
    <div class="container">
        <LoadingBlock v-if="!hasUser && isLoading"/>
        <RouterView v-if="hasUser"/>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import LoadingBlock from "../../Common/UI/LoadingBlock.vue"

export default {

    components: {
        LoadingBlock,
    },

    computed: {
        ...mapGetters({
            isLoading: 'user/isLoading',
            hasUser: 'user/hasUser',
            user: 'user/getUser',
        }),
    },

    created() {
        this.$store.dispatch("user/clear")
        this.loadUser(this.$route.params.id)
    },

    methods: {

        loadUser(id) {
            this.$store.dispatch("user/getUser", id)
                .catch((error) => {
                    this.errorMessage(error.response.data.message)
                })
        },

    },

}
</script>
